<script type="text/ecmascript-6">
    import DesignerQuestionFrenchMaster from "../DesignerQuestionFrenchMaster.vue";
    import TileQuestion from "../mixin/TileQuestion.vue";

    export default {
        mixins: [
            DesignerQuestionFrenchMaster,
            TileQuestion
        ],
        props: {
            helper_text: {
                default() {
                    return 'As viewed from outside';
                },
            }
        },
        computed: {
            thumbURL(){
                return '/thumb/french-master/';
            },
        }
    }
</script>
